import React from 'react';

const reloadPage = () => {
  window.location.reload();
};

const UpdateBanner = ({ onDismiss }) => {
  return (
    <div className="update-banner" role="status" aria-live="polite">
      <div className="update-banner__inner">
        <div className="update-banner__label">Updated</div>
        <div className="update-banner__content">
          <p className="update-banner__title">A new version is available</p>
          <p className="update-banner__message">
            Reload to make sure you&apos;re using the latest booking experience.
          </p>
        </div>
        <div className="update-banner__actions">
          <button type="button" className="btn btn-primary btn-sm" onClick={reloadPage}>
            Reload now
          </button>
          <button
            type="button"
            className="btn btn-link btn-sm"
            onClick={onDismiss}
            aria-label="Dismiss update notice"
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateBanner;